export default __webpack_public_path__ + "static/media/account_circle_blue.1ca894b3.svg";